import moment from 'moment'

export function formatDate(value, format) {
  if (!value) return ''
  return moment.utc(value).format(format)
}
